import type { MessageKey } from "./ru"

export const ukMessages = {
  "common.loading": "Завантаження...",
  "common.error": "Помилка",
  "common.back": "Назад",
  "common.next": "Далі",
  "common.search": "Пошук",
  "auth.loginErrorTitle": "Помилка входу",
  "auth.openViaTelegram": "Відкрийте застосунок через Telegram",
  "auth.telegramRequired": "Застосунок потрібно відкрити через Telegram",
  "auth.authorizationError": "Помилка авторизації",
  "device.rotatePortrait": "Поверніть пристрій вертикально",
  "country.brazil": "Бразилія",
  "country.vietnam": "Вʼєтнам",
  "country.egypt": "Єгипет",
  "country.india": "Індія",
  "country.indonesia": "Індонезія",
  "country.iran": "Іран",
  "country.spain": "Іспанія",
  "country.italy": "Італія",
  "country.kazakhstan": "Казахстан",
  "country.colombia": "Колумбія",
  "country.malaysia": "Малайзія",
  "country.mexico": "Мексика",
  "country.nigeria": "Нігерія",
  "country.pakistan": "Пакистан",
  "country.russia": "Росія",
  "country.usa": "США",
  "country.turkey": "Туреччина",
  "country.uzbekistan": "Узбекистан",
  "country.ukraine": "Україна",
  "country.philippines": "Філіппіни",
  "countrySelection.chooseCountry": "Оберіть країну",
  "countrySelection.openAria": "Обрати країну",
  "languageSelection.chooseLanguage": "Оберіть мову",
  "commercial.direction.autotrade": "Автоторг",
  "commercial.direction.insurance": "Страхування",
  "commercial.direction.pitstop": "Піт-стоп",
  "commercial.direction.techhelp": "Автодопомога",
  "commercial.searchLabel": "Пошук BeepApp",
  "commercial.cityPlaceholder": "Введіть місто",
  "commercial.emptyTitle": "Сьогодні пропозицій немає",
  "commercial.emptyLine1": "У вашому місті поки немає активних партнерів BeepApp",
  "commercial.emptyLine2": "Ми вже працюємо над їх пошуком і підключенням",
  "commercial.emptyLine3": "Нові пропозиції зʼявляться тут автоматично",
  "commercial.helperLine1": "Вкажіть місто, щоб переглянути",
  "commercial.helperLine2": "доступні пропозиції",
  "commercial.partnerPrompt": "Хочете стати партнером BeepApp?",
  "commercial.apply": "Подати заявку",
  "main.admin": "Адмін",
  "main.garage": "Гараж",
  "main.signalSent": "Сигнал надіслано",
  "main.partnerInviteUnavailable": "Партнерське запрошення недоступне",
  "main.enterPlate": "Введіть держномер",
  "main.searchError": "Помилка пошуку",
  "main.signalSendError": "Не вдалося надіслати сигнал",
  "main.shareCardPrefix": "Картка номера",
  "main.shareLinkError": "Не вдалося підготувати посилання",
  "main.searchByPlateAria": "Пошук за держномером",
  "main.russianPlateAria": "Російський держномер",
  "main.plateAria": "Держномер",
  "main.findPlateAria": "Знайти номер",
  "main.loadingVehicle": "Завантажуємо картку номера…",
  "main.leaveSignal": "Залишити сигнал",
  "main.share": "Поділитися",
  "signalSelection.chooseType": "Оберіть тип сигналу",
  "signalSelection.category.attention": "Особисті",
  "signalSelection.category.road": "Дорожні",
  "signalSelection.category.urgent": "Термінові",
  "signalSelection.chooseSignal": "Оберіть сигнал",
  "signalSelection.suggestOwn": "Запропонувати свій варіант",
  "signalConfirmation.title": "Підтвердження сигналу",
  "signalConfirmation.plateHeading": "Перевірте номер автомобіля",
  "signalConfirmation.signalHeading": "Перевірте обраний сигнал",
  "signalConfirmation.replyTitle": "Дозволити відповідь у Telegram",
  "signalConfirmation.replyBody": "Увімкніть цю функцію, щоб власник номера міг\nнаписати вам у Telegram. Відповідь можлива лише за\nнаявності у вас @username. Рішення відповідати\nзалишається за власником номера.",
  "signalConfirmation.consentText": "Підтверджую, що сигнал відповідає\nреальній ситуації та не є спамом\nабо неправдивим повідомленням.",
  "signalConfirmation.warning": "Після надсилання змінити сигнал\nбуде неможливо",
  "signalConfirmation.sending": "Надсилаємо…",
  "signalConfirmation.send": "Надіслати",
  "partner.loadingAria": "Завантаження",
  "partner.title": "Партнерська програма",
  "partner.offerLine1": "Отримуйте безстроково 30% з усіх платежів",
  "partner.offerLine2": "запрошених вами користувачів у BeepApp",
  "partner.offerLine3": "через affiliate-програму Telegram",
  "partner.connectUnavailable": "Підключення стане доступним після налаштування Telegram Affiliate програми.",
  "partner.connectTelegram": "Підключитися в Telegram",
  "partner.qrAria": "QR-код партнерського посилання",
  "partner.download": "Завантажити",
  "partner.promoHeading": "Створіть персональний промокод",
  "partner.promoHelperLine1": "Промокод активує додатковий рік підписки",
  "partner.promoHelperLine2": "і допомагає залучати користувачів",
  "partner.promoAria": "Промокод",
  "partner.affiliateHeading": "Ваше affiliate-посилання",
  "partner.affiliateHelper": "Збережіть посилання, щоб створити персональний QR-код",
  "partner.affiliateAria": "Affiliate-посилання",
  "partner.qrNoteLine1": "QR-код можна розміщувати на автомобілі,",
  "partner.qrNoteLine2": "у соціальних мережах і рекламних матеріалах",
  "partner.save": "Зберегти",
  "partner.reset": "Скинути",
  "partner.resetConfirm": "Скинути збережене affiliate-посилання? Промокод залишиться за вами.",
  "partner.promoFormatError": "Промокод має містити від 4 до 15 символів.",
  "partner.affiliateHostError": "Дозволені лише посилання t.me або telegram.me.",
  "partner.affiliatePathError": "У посиланні відсутній Telegram-шлях.",
  "partner.affiliateFormatError": "Некоректне affiliate-посилання.",
  "partner.loadError": "Помилка завантаження",
  "partner.checkInputError": "Перевірте введені дані",
  "garageActivation.promoInvalid": "Промокод недійсний",
  "garageActivation.plateOccupied": "Цей держномер уже привʼязаний",
  "garageActivation.activateError": "Не вдалося активувати Гараж",
  "garageEntry.loadJournalError": "Помилка завантаження журналу",
  "garageEntry.loadStatusesError": "Помилка завантаження статусів",
  "garageEntry.activationSuccess": "Гараж успішно активовано",
  "garageEntry.plateAttached": "Номер привʼязано",
  "garageEntry.attachError": "Не вдалося привʼязати номер",
  "garageEntry.activationNote": "Активуйте ваш гараж",
  "garageSheet.activationTitle": "Активація гаража",
  "garageSheet.plateHelper": "Введіть держномер автомобіля",
  "garageSheet.promoHelper": "У вас є промокод?",
  "garageSheet.cleanBonusLine1": "Після активації у вас буде 1 година",
  "garageSheet.cleanBonusLine2": "на безкоштовний «Чистий старт»",
  "garageSheet.activationFor": "Активація на",
  "garageSheet.cost": "Вартість",
  "garageSheet.ownerConsentLine1": "Підтверджую, що є власником",
  "garageSheet.ownerConsentLine2": "транспортного засобу із зазначеним",
  "garageSheet.ownerConsentLine3": "реєстраційним номером.",
  "garageSheet.processing": "Виконується...",
  "garageSheet.attach": "Привʼязати",
  "garageSheet.pay": "Оплатити",
  "garageLifecycle.cleanTitle": "Чистий старт",
  "garageLifecycle.deactivateTitle": "Деактивація Гаража",
  "garageLifecycle.cleanWarningLine1": "Історію номера буде видалено",
  "garageLifecycle.cleanWarningLine2": "без можливості відновлення!",
  "garageLifecycle.deactivateWarningLine1": "Після деактивації доступ до функцій",
  "garageLifecycle.deactivateWarningLine2": "активного «Гаража» буде припинено",
  "garageLifecycle.willBeDeleted": "БУДЕ ВИДАЛЕНО",
  "garageLifecycle.cleanRemovedLine1": "• Усі записи з «Бортового журналу»",
  "garageLifecycle.cleanRemovedLine2": "• Історія отриманих сигналів",
  "garageLifecycle.cleanRemovedLine3": "• Публічні лічильники сигналів",
  "garageLifecycle.cleanRemovedLine4": "  на картці номера",
  "garageLifecycle.willRemain": "ЗБЕРЕЖЕТЬСЯ",
  "garageLifecycle.cleanPreservedLine1": "• Привʼязка номера до «Гаража»",
  "garageLifecycle.cleanPreservedLine2": "• Залишок терміну активації",
  "garageLifecycle.cleanPreservedLine3": "• Обраний статус номера",
  "garageLifecycle.cleanPreservedLine4": "• Загальна кількість переглядів картки",
  "garageLifecycle.freeFirstHour": "Безкоштовно в першу годину",
  "garageLifecycle.willBecomeUnavailable": "СТАНЕ НЕДОСТУПНО",
  "garageLifecycle.deactivateRemovedLine1": "• «Бортовий журнал»",
  "garageLifecycle.deactivateRemovedLine2": "• Вибір і використання статусу номера",
  "garageLifecycle.deactivateRemovedLine3": "• Автоматично покинете «Автоклан»",
  "garageLifecycle.deactivateRemovedLine4": "• «Автоторг»",
  "garageLifecycle.deactivateRemovedLine5": "• «Страхування»",
  "garageLifecycle.deactivateRemovedLine6": "• «Піт-стоп»",
  "garageLifecycle.deactivateRemovedLine7": "• «Автодопомога»",
  "garageLifecycle.deactivateRemovedLine8": "• Держномер буде відвʼязано від «Гаража»",
  "garageLifecycle.willRemainAvailable": "ЗАЛИШАТЬСЯ ДОСТУПНИМИ",
  "garageLifecycle.deactivatePreservedLine1": "• «Попутник»",
  "garageLifecycle.deactivatePreservedLine2": "• «Диспетчер»",
  "garageLifecycle.deactivatePreservedLine3": "• Пошук за держномером і перегляд",
  "garageLifecycle.deactivatePreservedLine4": "  публічної картки автомобіля",
  "garageLifecycle.deactivatePreservedLine5": "• Можливість у будь-який час",
  "garageLifecycle.deactivatePreservedLine6": "  знову активувати «Гараж»",
  "garageLifecycle.cleanConsentLine1": "Підтверджую згоду на видалення",
  "garageLifecycle.cleanConsentLine2": "всієї історії цього номера",
  "garageLifecycle.cleanConsentLine3": "без можливості відновлення.",
  "garageLifecycle.deactivateConsentLine1": "Підтверджую деактивацію та",
  "garageLifecycle.deactivateConsentLine2": "припинення доступу до всіх",
  "garageLifecycle.deactivateConsentLine3": "функцій активного «Гаража».",
  "garageLifecycle.clean": "Очистити",
  "garageLifecycle.deactivate": "Деактивувати",
} satisfies Record<MessageKey, string>
